import { useQuery } from 'react-query';
import { getCompetitionLeaderBoard } from 'api/services/competitions';

const useCompetitionLeaderboard = (competitionId, page, count) => {
  const {
    data = null,
    error,
    refetch,
    isLoading,
    isRefetching,
  } = useQuery({
    queryKey: ['competitionLeaderboard', competitionId, page, count],
    queryFn: getCompetitionLeaderBoard(page, count, competitionId),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    retry: false,
    enabled: true,
  });
  if (!isLoading && data !== null) {
    const { leaderBoard, total } = data;

    const leaderBoardUsers = leaderBoard ? [...leaderBoard] : [];

    return {
      leaderBoardUsers,
      total,
      error,
      refetch,
      isLoading,
      isRefetching,
    };
  }

  return {
    leaderBoardUsers: [],
    total: 0,
    error,
    refetch,
    isLoading,
    isRefetching,
  };
};

export default useCompetitionLeaderboard;
